import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
export var Page2 = function () { return (React.createElement(Fragment, null,
    React.createElement("h1", null, "This is page 2"),
    React.createElement(Link, { to: '/' }, "Go to Home"))); };
